import { WebGLBackend } from "../backends/webgl-backend"
import { Texture } from "../backends/webgl/texture"
import { TextureFormat } from "../backends/webgl/texture-format"

export class TexturesPool {
	private freeList: Texture[] = []
	private usedList: Texture[] = []
	private backend: WebGLBackend
	private format: TextureFormat

	constructor(backend: WebGLBackend, format: TextureFormat) {
		this.backend = backend
		this.format = format
	}

	private createTexture(
		width: number,
		height: number,
		format: TextureFormat,
		label: string,
	): Texture {
		const texture = this.backend.createTexture({
			label,
			format: format,
			width: Math.round(width),
			height: Math.round(height),
			mag: "linear",
			min: "linear",
			mips: false,
		})
		return texture
	}

	withdraw(width: number, height: number, label: string): Texture {
		let tex = this.freeList.pop()
		if (tex) {
			tex.updateLabel(label)
			tex.updateSize(width, height)
		} else {
			tex = this.createTexture(width, height, this.format, label)
		}

		if (tex) {
			this.usedList.push(tex)
		}

		return tex
	}

	deposit(tex: Texture | undefined | null) {
		if (!tex) {
			return
		}

		const index = this.usedList.findIndex((value) => value === tex)
		if (index >= 0) {
			this.usedList.splice(index, 1)
			this.freeList.push(tex)
		}
	}

	reduceCapacity() {
		for (const tex of this.freeList) {
			tex.delete()
		}
		this.freeList = []
	}

	dispose() {
		this.reduceCapacity()

		for (const tex of this.usedList) {
			tex.delete()
		}
		this.usedList = []
	}
}
